import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'tech-core-quiz-start',
  standalone: false,
  templateUrl: './start.component.html',
  styleUrl: './start.component.scss'
})
export class StartComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

  navigateToSignUp() {
    this.router.navigate(['/signup']);
  }

  navigateToScoreboard() {
    this.router.navigate(['/score-intro']);
  }
}
